
export default function GeneralHeroSection({title, blurb, imageURL, imageALT, imageSubtitle}) {

    return (

        <div>
            <div
                className="bg-gray-200-trimmed theme-dark bg-color _none pt-4 bg-pattern">
                <div className="container">
                    <div className="layout row layout-builder__layout">
                        <div className="col-12">
                            <div className="_none">
                                <h1 className="w-100 fw-bold m-auto mb-7 mb-lg-8 d-flex align-items-center justify-content-center flex-wrap text-center text-4xl">
                                    {title}
                                </h1>
                            </div>
                            <div className="_none">
                                <div
                                    className="hero-banner full-story mt-n5 text-align-center">
                                    <div
                                        className="image-container my-0 mx-auto position-relative">
                                        <div className="hero__image-1">
                                            <div className="view-mode-full">
                                                <div>
                                                    <img
                                                        src={imageURL}
                                                        width="1095" height="450"
                                                        alt={imageALT}
                                                        loading="lazy"
                                                        className="img-fluid rounded"/>
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            imageSubtitle &&
                                            <div
                                                className="position-absolute date bg-white border-2 border-info text-center p-3 px-lg-4 py-lg-3 text-uppercase text-info pfs-4 pfs-lg-3">
                                                {imageSubtitle}
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="mt-4 space-y-2">
                            <div>
                                <p>{blurb}</p>
                            </div>
                            <div className="ck-widget bs_grid"
                                 contentEditable="false">
                                <div className="ck-widget row"
                                     data-row-none="none"
                                     data-row-sm="none"
                                     data-row-md="none"
                                     data-row-lg="3_6_3"
                                     data-row-xl="none"
                                     data-row-xxl="none"
                                     contentEditable="false">
                                    <div className="col-lg-3">
                                        <p>&nbsp;</p>
                                    </div>
                                    {/*<div className="col-lg-6">*/}
                                    {/*<div*/}
                                    {/*        className="media-library-item media-library-item--grid shadow border border-10 border-white">*/}
                                    {/*        <video*/}
                                    {/*            controls="controls"*/}
                                    {/*            className="plyr plyr-player"*/}
                                    {/*            playsInline*/}
                                    {/*            data-plyr-config="{&quot;resetOnEnd&quot;:true,&quot;hideControls&quot;:true,&quot;controls&quot;:[&quot;play-large&quot;,&quot;play&quot;,&quot;progress&quot;,&quot;current-time&quot;,&quot;mute&quot;,&quot;volume&quot;,&quot;settings&quot;,&quot;fullscreen&quot;],&quot;youtube&quot;:{&quot;noCookie&quot;:true}}"*/}
                                    {/*            data-poster="https://www.saschina.org/sites/default/files/2025-09/Video.png">*/}
                                    {/*            <source*/}
                                    {/*                src="https://www.saschina.org/sites/default/files/2025-09/Meet%20Jesse%20Final.webm"*/}
                                    {/*                type="video/webm"/>*/}
                                    {/*            <track src*/}
                                    {/*                   kind="captions"*/}
                                    {/*                   srcLang="en"*/}
                                    {/*                   label="English"/>*/}
                                    {/*        </video>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    <div className="col-lg-3">
                                        <p>&nbsp;</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    )
}